<!-- 代收贷款 -->
<template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug
      :btndata="BTN_CONFIG"
      @btnEvent="callBack"
      @clearBtns="clearBtns"
      @moreParam="moreParam"
      @queryBtn_ok="queryBtn_ok"
      @moreHandle="topCommandBtns"
      ref="btnList"
    />
    <!-- 查询列表 -->
    <input-plug
      ref="queryForm"
      :form-config="baseConfig"
      :form-data="queryData"
      :More="isHaseMore"
      @changeCallback="rowCallback"
    >
      <template slot="time1">
        <multitime
          :timeType="timeType"
          :timeTypes="timeTypes"
          :startTime="startTime_a"
          :endTime="endTime_a"
          @timestatus="timestatus"
          @queryBtn_ok="queryBtn_time"
        />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug
      ref="mytable"
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      @selectChange="handleSelectionChange"
      @jumpPage="goYdDetails"
    />
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>
    <!-- 收回确认 -->
    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <dia-form
        :diaFormConfig="diaFormConfig"
        :baseModel="baseModel"
        ref="diaform"
        :rules="formRules"
        :Reset="isShowDialog"
      >
        <template slot="phone">
          <uploadimgs
            @input="changeFileList"
            :fileNameLists="fileNameLists"
            :limit="6"
          />
        </template>
      </dia-form>
    </my-dialog>
    <!-- 支付确认 -->
    <!-- <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle(2)"
      :isShowDialog="isShowDialog_2"
      @handleCloseDia="handleCloseDia(2)"
      @diaCancelBtn="diaCancelBtn(2)"
      @diaConfirmBtn="diaConfirmBtn(2)"
    >
      <dia-form :diaFormConfig="diaFormConfig_2" :baseModel="baseModel">
        <template slot="phone">
          <img-upload />
        </template>
      </dia-form>
    </my-dialog>-->
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug
        ref="queryForm"
        :form-config="baseConfig"
        :form-data="queryData"
        :More="true"
        @changeCallback="rowCallback"
      >
        <template slot="time1">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
<script>
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    uploadimgs,
    RecordTable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "代收货款", //导出时默认文件名
        apiName: "/admin/v3/tms/finance/getAgentAmountFinanceOutList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "收回确认",
          method: "tackBackComfirm",
          permissVal: "aaaaa",
        },
        {
          name: "支付确认",
          method: "payComfirm",
          permissVal: "aaaaa",
        },
        {
          name: "取消收回",
          method: "UnTackBack",
          permissVal: "aaaaa",
        },

        {
          name: "取消支付",
          method: "UnPayComfirm",
          permissVal: "aaaaa",
        },

        {
          type: true,
          name: "更多操作",
          options: [
            {
              handleName: "dc",
              label: "导出",
            },
            {
              handleName: "bgsz",
              label: "表格设置",
            },
            {
              handleName: "dy",
              label: "打印",
            },
          ],
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "运单号",
          field: "waybillNumber",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "收回状态",
          field: "writeoffStatus",
          placeholder: "请输入",
          selectOptions: [
            { label: "未核销", val: "wei_he_xiao:writeoff_status" },
            { label: "未核销", val: "yi_he_xiao:writeoff_status" },
          ],
        },
        {
          type: "doubleSelect",
          label: "结算对象",
          selectItem: [
            {
              field: "objectStatusConfDictId",
              placeholder: "请选择",
              setLabel: "val",
              setValue: "confDictId",
              selectChange: "GetUserDownList",
              selectOptions: [],
            },
            {
              field: "objectName",
              placeholder: "请选择",
              setLabel: "name",
              setValue: "name",
              allowCreate: false,
              selectOptions: [],
            },
          ],
        },
        {
          type: "select",
          label: "支付状态",
          field: "payWriteoffStatus",
          placeholder: "请输入",
          selectOptions: [{ label: "全部", val: "1" }],
        },
        {
          type: "select",
          label: "对账单",
          field: "hasCreateStatement",
          placeholder: "请选择",
          setLabel: "name",
          setValue: "value",
          selectOptions: [
            {
              name: "已生成",
              value: "1",
            },
            {
              name: "未生成",
              value: "0",
            },
          ],
        },
        {
          type: "deptTree",
          label: "责任部门",
          field: "dutyDeptIds",
          placeholder: "请选择",
          selectOptions: [],
        },
      ],

      queryData: {
        waybillNumber: "",
        writeoffStatus: "",
        objectStatusConfDictId: "",
        objectName: "",
        payWriteoffStatus: "",
        hasCreateStatement: "0",
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "创建日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "收支单据号",
          field: "number",
          //   Hyperlink: true, //是否展示超链接 可选填
          width: "120", // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: "责任部门",
          field: "dutyDeptName",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "收支类型",
          field: "financeInTypeShow",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "单据类型",
          field: "documentStatusShow",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "来源单据",
          field: "documentNumber",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "费项类型",
          field: "categoryName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "费项",
          field: "serviceName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算对象(收款人)",
          field: "payObjectName",
          width: "160",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "收货人(支付方)",
          field: "objectName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "应收金额",
          field: "settlementAmount",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "货款扣运费",
          field: "goodsDeductedAmoun",
          sort: 2,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "手续费",
          field: "serviceAmount",
          sort: 2,
          isShow: true,
          isTotal: true,
          isSort: true,
        },

        {
          name: "结算金额",
          field: "paySettlementAmount",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "核销时间",
          field: "statementTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "开单备注",
          field: "comment",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "收回状态",
          field: "writeoffStatusShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "收回操作人",
          field: "writeoffUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "收回操作时间",
          field: "writeoffTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "支付状态",
          field: "payWriteoffStatusShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "支付操作人",
          field: "payWriteoffUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "支付操作时间",
          field: "payWriteoffTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
      ],
      pageGroupName: "CollectLoans",
      sortName: "代收货款", //  排序名
      // 收回弹窗
      diaWidth: "60%",
      dialogTitle: "收回确认",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: "代收款金额",
              itemType: "input",
              field: "moneys",
              disabled: true,
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "收款资金账号",
              itemType: "select",
              field: "accountId",
              labelwidth: 130,
              setLabel: "account",
              setValue: "assetaccountId",
              placeholder: "请选择",
              options: [],
            },
            {
              span: 8,
              title: "收款时间",
              itemType: "datetime",
              field: "writeOffTime",
              placeholder: "选择时间",
            },
          ],
        },

        {
          gutter: 16,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "writeoffComment",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 24,
              title: "图片",
              itemType: "upload",
              slot: "phone",
            },
          ],
        },
        {
          gutter: 16,
          formItem: [
            {
              span: 8,
              title: "操作时间",
              itemType: "input",
              field: "oprationTime",
              disabled: true,
              placeholder: "自动填写",
            },
            {
              span: 8,
              title: "操作人",
              itemType: "input",
              field: "oprationer",
              disabled: true,
              placeholder: "自动填写",
            },
          ],
        },
      ],
      baseModel: {
        moneys: 0,
        oprationer: "",
        oprationTime: "",
      },
      defaultBaseModel: {
        accountId: null,
        financeIds: null,
        writeOffPics: null,
        writeOffTime: null,
        writeoffComment: null,
      },
      fileNameLists: [],
      formRules: {
        writeOffTime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        accountId: [{ required: true, message: "请选择", trigger: "change" }],
      },
      //支付确认
      isShowDialog_2: false,
      diaFormConfig_2: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "代收款金额",
              itemType: "input",
              field: "aaa",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "收款资金账号",
              itemType: "select",
              field: "aaa",
              placeholder: "请选择",
              options: [
                {
                  label: "上楼费",
                  val: 1,
                },
                {
                  label: "验货费",
                  val: 1,
                },
                {
                  label: "加急费",
                  val: 1,
                },
              ],
            },
            {
              span: 8,
              title: "收款时间",
              itemType: "timeselect",
              field: "aaa",
              datetype: "datetime",
              placeholder: "选择时间",
            },
          ],
        },

        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "aaa",
              placeholder: "请选择",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "图片",
              itemType: "upload",
              slot: "phone",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "操作人",
              itemType: "select",
              field: "aaa",
              placeholder: "请选择",
              options: [],
            },
            {
              span: 8,
              title: "操作时间",
              itemType: "timeselect",
              field: "aaa",
              datetype: "datetime",
              placeholder: "选择时间",
            },
          ],
        },
      ],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    console.log(this.myTableHeard.length)
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.getConfDictValDownList("object_status");
    this.getAssetaccountList();
    this.GetData();
  },
  methods: {
    // 获取代收货款核销列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.waybillNumbers = [];
      this.queryData.startCreateTime = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endCreateTime = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.$API.AgentAmountFinanceOutList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---代收货款核销列表`);
        }
      });
    },

    rowCallback(data, name) {
      this[name](data);
    },

    // 获取结算对象类型
    getConfDictValDownList(PARAM) {
      this.$API.wtl_getConfDictValDownList({ dictType: PARAM }).then((res) => {
        if (res.data.status === "success") {
          this.baseConfig[3].selectItem[0].selectOptions =
            res.data.result || [];
        } else {
          console.log(res.data.message);
        }
      });
    },

    // 根据结算对象类型获取结算对象
    GetUserDownList(e) {
      let arr = this.baseConfig[3].selectItem[0].selectOptions;
      let num = arr.findIndex((element) => element.confDictId == e);
      let objectKey = arr[num].key;
      // 结算对象为其他的时候自动输入
      if (objectKey === "other") {
        this.queryData.objectName = "";
        this.baseConfig[3].selectItem[1].allowCreate = true;
        this.baseConfig[3].selectItem[1].placeholder = "请输入";
        this.baseConfig[3].selectItem[1].selectOptions = [];
      } else {
        this.baseConfig[3].selectItem[1].allowCreate = false;
        this.baseConfig[3].selectItem[1].placeholder = "请选择";
        this.$API
          .wtl_getObjectUserDownList({
            key: objectKey,
            pageStart: 1,
            pageTotal: 1000,
          })
          .then((res) => {
            if (res.data.status === "success") {
              let result = res.data.result?.data || [];
              this.queryData.objectName = "";
              this.baseConfig[3].selectItem[1].selectOptions = result;
            }
          });
      }
    },

    // 获取资金账号列表
    getAssetaccountList() {
      this.$API.assetaccountList().then((res) => {
        if (res.data.status === "success") {
          this.diaFormConfig[0].formItem[1].options =
            res.data.result?.data || [];
        } else {
          console.log(res.data.message);
        }
      });
    },

    // 收回确认
    tackBackComfirm(data, type) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length > 0) {
        let moneyNum = 0;
        this.baseModel.financeIds = [];
        this.baseModel.oprationer = this.selectTableData[0].writeoffUserName;
        this.baseModel.oprationTime = this.selectTableData[0].createTime;
        for (let i in this.selectTableData) {
          moneyNum += Number(this.selectTableData[i].settlementAmount);
          this.baseModel.financeIds.push(this.selectTableData[i].financeInId);
        }
        this.baseModel.moneys = moneyNum.toFixed(2);
        if (type === "pay_type") {
          this.diaFormConfig[0].formItem[1].title = "付款资金账号";
          this.diaFormConfig[0].formItem[2].title = "付款时间";
          this.dialogTitle = "支付确认";
        } else {
          this.diaFormConfig[0].formItem[1].title = "收款资金账号";
          this.diaFormConfig[0].formItem[2].title = "收款时间";
          this.dialogTitle = "收回确认";
        }
        this.isShowDialog = true;
      } else {
        this.$message.error("请选择至少一条数据进行操作");
        return false;
      }
    },

    // 支付确认
    payComfirm(data) {
      this.tackBackComfirm(data, "pay_type");
    },

    // 取消收回
    UnTackBack(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length > 0) {
        let writeOffReq = {
          financeInIds: new Array(),
        };
        for (let i in this.selectTableData) {
          writeOffReq.financeInIds.push(this.selectTableData[i].financeInId);
        }
        this.$API.agentAmountUnPay(writeOffReq).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.GetData();
          }
        });
      } else {
        this.$message.error("请选择至少一条数据进行操作");
        return false;
      }
    },

    // 取消支付
    UnPayComfirm(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length > 0) {
        let writeOffReq = {
          financeInIds: new Array(),
        };
        for (let i in this.selectTableData) {
          writeOffReq.financeInIds.push(this.selectTableData[i].financeInId);
        }
        this.$API.agentAmountUnWriteOff(writeOffReq).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.GetData();
          }
        });
      } else {
        this.$message.error("请选择至少一条数据进行操作");
        return false;
      }
    },

    // 整单核销选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.startTime_a = "";
      this.endTime_a = "";
      this.queryData.objectName = "";
      this.queryData.objectStatusConfDictId = "";
      this.GetData();
    },

    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 时间查询框选择时间时的事件
    queryBtn_time(t1, t2) {
      this.startTime_a = t1;
      this.endTime_a = t2;
      if (t1 && t2) {
        this.GetData();
      }
    },
    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // // 导出
        // this.$COMAPI.exportBtn({
        //   pageGroupName: this.pageGroupName, //页面标识
        //   myTableHeard: this.myTableHeard, //表头数组
        //   className: this.className, //列表标识
        //   tableData: this.tableConfig.tableData, //数据源
        //   sheetName: "表名(暂无效)", //表名
        // });
        this.isShowDialog_dc = true;
      }
    },

    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$router.push({
        path: "/FM/OrderDetails/",
      });
    },

    // 整单核销
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.baseModel = {
        moneys: 0,
        oprationer: "",
        oprationTime: "",
      };
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          param.writeOffPics = [];
          for (let i in this.fileNameLists) {
            param.writeOffPics.push(this.fileNameLists[i].name);
          }
          param.financeIds = this.baseModel.financeIds;
          if (this.dialogTitle == "收回确认") {
            // 应收整单核销
            this.$API.financeInWriteOff(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
          if (this.dialogTitle == "支付确认") {
            // 应付整单核销
            this.$API.financeOutWriteOff(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
  },
};
</script>
<style scoped lang="less"></style>
